import { createSlice } from '@reduxjs/toolkit';

import { reportsApi } from '@/integrations/app.api/reports.api';

import { type TTemplatesStore } from '../types/store';
import { type TTemplateDto } from '../types/templates';
import { createAsyncThunk } from './create-async-thunk';

const initialState: TTemplatesStore = {
  isLoading: false,
  templates: []
};

export const getTemplates = createAsyncThunk(
  'templates/getTemplates',
  async (): Promise<any> => {
    return reportsApi.getTemplates();
  }
);

export const createTemplate = createAsyncThunk(
  'templates/createTemplate',
  async (data: TTemplateDto): Promise<any> => {
    return reportsApi.createTemplate(data);
  }
);

export const redactTemplate = createAsyncThunk(
  'templates/redactTemplate',
  async (data: {
    templateId: string;
    template: TTemplateDto;
  }): Promise<any> => {
    return reportsApi.redactTemplate(data);
  }
);

export const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTemplates.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTemplates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.templates = action.payload;
      })
      .addCase(redactTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(redactTemplate.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(redactTemplate.fulfilled, (state) => {
        state.isLoading = false;
      });
  }
});
